import GetAdminsListForProjectDetailRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetAdminsListForProjectDetailRequest";
import GetAdminsListForProjectDetailResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetAdminsListForProjectDetailResponse";
import { AdminModel, SaveAdminsModel, UserModel } from "../models";
import OwnedUsersResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/OwnedUsersResponse";
import UpsertProjectAdminListRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/UpsertProjectAdminListRequest";
import UpsertProjectAdminListRequestItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/UpsertProjectAdminListRequestItem";

export const mapGetProjectsAdminsRequest = (projetId: number) =>
  new GetAdminsListForProjectDetailRequest({
    ProjectId: projetId,
  });

export const mapGetProjectsAdminsResponse = (response: GetAdminsListForProjectDetailResponse) =>
  response.Items.map(
    (item) =>
      new AdminModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Photo: item.Foto,
        AvatarColor: item.AvatarColor,
        CanCustomizeOrder: item.CanCustomizeOrder,
      }),
  );

export const mapGetUsersAssignProjectAdminsResponse = (response: OwnedUsersResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Photo: item.Foto,
        AvatarColor: item.AvatarColor,
      }),
  );

export const mapSaveProjectsAdminsRequest = (request: SaveAdminsModel) =>
  new UpsertProjectAdminListRequest({
    ProjectId: request.ProjectId,
    AdminList: request.Admins.map(
      (admin) =>
        new UpsertProjectAdminListRequestItem({
          UserId: admin.Id,
          CanCustomizeOrder: admin.CanCustomizeOrder,
        }),
    ),
    RemoveTaskPerformer: request.RemoveTaskPerformer,
    RemoveTaskObserver: request.RemoveTaskObserver,
    RemoveQueueTasksAccess: request.RemoveQueueTasksAccess,
  });
